module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-7d89fd6e!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-radio-list/index.vue
// module id = 519
// module chunks = 0 1